import {alias, createModelSchema, list} from "serializr";
import {SmartOfferBundle} from "../bundle-core/SmartOfferBundle";
import {SmartOfferBundleKind} from "../bundle-core/SmartOfferBundleKind";
import {SmartOfferBundleTreasureType} from "../bundle-treasure/SmartOfferBundleTreasureType";
import {RewardModel} from "@/modules/redactor/models/reward/RewardModel";
import {RedactorUtils} from "@/modules/redactor/core/RedactorUtils";
import {Schema} from "@/common/Schema";
import {Currency} from "@/modules/redactor/models/currency/Currency";
import {TreasureLevelConfig} from "@/modules/redactor/models/smart-offer/bundle-treasure/TreasureLevelConfig";
import {TreasureLowerCapConfig} from "@/modules/redactor/models/smart-offer/bundle-treasure/TreasureLowerCapConfig";


export class SmartOfferBundleTreasure extends SmartOfferBundle {

    constructor() {
        super(SmartOfferBundleKind.TREASURE);

        this._type = null;
        this._winReward = null;
        this._playProduct = null;
        this._continuePrice = [];

        this._basicLevels = [];
        this._bonusLevels = [];
        this._bonusUnlimited = false;

        this._lowerCapConfig = null;

        this._areYouSureType = 0;
    }

    get type() {
        return this._type;
    }

    set type(value) {
        this._type = value;
    }

    get winReward() {
        return this._winReward;
    }

    set winReward(value) {
        this._winReward = value;
    }

    get playProduct() {
        return this._playProduct;
    }

    set playProduct(value) {
        this._playProduct = value;
    }

    get continuePrice() {
        return this._continuePrice;
    }

    set continuePrice(value) {
        this._continuePrice = value;
    }

    get basicLevels() {
        return this._basicLevels;
    }

    set basicLevels(value) {
        this._basicLevels = value;
    }

    get bonusLevels() {
        return this._bonusLevels;
    }

    set bonusLevels(value) {
        this._bonusLevels = value;
    }

    get bonusUnlimited() {
        return this._bonusUnlimited;
    }

    set bonusUnlimited(value) {
        this._bonusUnlimited = value;
    }

    get lowerCapConfig() {
        return this._lowerCapConfig;
    }

    set lowerCapConfig(value) {
        this._lowerCapConfig = value;
    }

    get areYouSureType() {
        return this._areYouSureType;
    }

    set areYouSureType(value) {
        this._areYouSureType = value;
    }

    valid() {

        if (!SmartOfferBundleTreasureType.is(this.type) || SmartOfferBundleTreasureType.isNone(this.type)) {
            return false;
        }

        if (!this.winReward || this.winReward.empty()) {
            return false;
        }

        if (this.winReward && !this.winReward.valid()) {
            return false;
        }

        if (!this.playProduct || !RedactorUtils.getProduct(this.playProduct)) {
            return false;
        }

        if (!this.continuePrice || this.continuePrice.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.basicLevels || this.basicLevels.length === 0) {
            return false;
        }

        if (this.basicLevels && this.basicLevels.some(v => !v || !v.valid())) {
            return false;
        }

        if (this.bonusLevels && this.bonusLevels.some(v => !v || !v.valid())) {
            return false;
        }

        if (!this.lowerCapConfig || !this.lowerCapConfig.valid()) {
            return false;
        }

        if(!Number.isInteger(this.areYouSureType) || this.areYouSureType < 0){
            return false;
        }

        return super.valid();
    }

    empty() {

        // if (!this.reward || this.reward.empty()) {
        //     return true;
        // }

        return super.empty();
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new SmartOfferBundleTreasure());
        } else if (target instanceof SmartOfferBundleTreasure) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(SmartOfferBundleTreasure, {
    _type: alias("type", SmartOfferBundleTreasureType.schema()),
    _winReward: alias("win_reward", RewardModel.schema()),
    _playProduct: alias("play_product", Schema.primitive()),
    _continuePrice: alias("continue_price", list(Currency.schema())),

    _basicLevels: alias("basic_levels", list(TreasureLevelConfig.schema())),
    _bonusLevels: alias("bonus_levels", list(TreasureLevelConfig.schema())),
    _bonusUnlimited: alias("bonus_unlimited", Schema.primitive()),
    _lowerCapConfig: alias("lower_cap_config", TreasureLowerCapConfig.schema()),
    _areYouSureType: alias("are_you_sure_type", Schema.primitive())
});
